import * as React from "react";
import styled from "styled-components";
import RowCheckbox from "components/common/EntityDataTable/RowCheckbox";
import TableHeaderCell from "./TableHeaderCell";
const SelectionHeader = styled(TableHeaderCell)`
  && {
    width: 1px;
  }
`;
const SelectionData = styled.td`
  && {
    width: 1px;
  }
`;
export const SelectAllHeaderCell = ({ checked, indeterminate, onChange }) => {
  const label = checked ? "Deselect all rows" : "Select all rows";
  return /* @__PURE__ */ React.createElement(SelectionHeader, null, /* @__PURE__ */ React.createElement(RowCheckbox, { checked, indeterminate, onChange, title: label, "aria-label": label }));
};
export const SelectRowCell = ({ checked, onChange, label }) => /* @__PURE__ */ React.createElement(SelectionData, null, /* @__PURE__ */ React.createElement(RowCheckbox, { checked, onChange, title: label, "aria-label": label }));
